import { render, staticRenderFns } from "./TheNavigation.vue?vue&type=template&id=20cc065a"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"
import style0 from "./TheNavigation.vue?vue&type=style&index=0&id=20cc065a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports